import Button from "./components/Button";
import _0back from "./images/0/back.png";
import _00 from "./images/0/0.jpg";
import _01 from "./images/0/1.jpg";
import _02 from "./images/0/2.jpg";
import _1back from "./images/1/back.jpeg";
import _10 from "./images/1/0.png";
import _11 from "./images/1/1.png";
import _12 from "./images/1/2.svg";
import _2back from "./images/2/back.jpg";
import _20 from "./images/2/0.webp";
import _21 from "./images/2/1.jpg";
import _22 from "./images/2/2.jpeg";
import _3back from "./images/3/innovpresenter.jpeg";
import _30 from "./images/3/0.jpg";
import _31 from "./images/3/ppt.jpeg";
import _32 from "./images/3/2.jpg";
import _4back from "./images/4/project.jpeg";
import _40 from "./images/4/0.jpeg";
import _41 from "./images/4/1.jpeg";
import _42 from "./images/4/2.jpg";
import _5back from "./images/5/game freak.jpeg";
import _50 from "./images/5/game freak.jpeg";
import _51 from "./images/5/1.jpeg";
import _52 from "./images/5/2.jpeg";
import _6back from "./images/6/codeblitz.jpeg";
import _60 from "./images/6/0.jpeg";
import _61 from "./images/6/1.jpeg";
import _62 from "./images/6/2.jpeg";
const events = [
	{
		title: "Innov Presenter",
		content: [
			<>
				<p>
				Delve deep into research realms! Unveil your discoveries, ignite discussions, and foster intellectual growth. Engage with peers, challenge perspectives, and leave a lasting impact. Elevate knowledge, inspire innovation, and shape tomorrow's advancements with your presentation skills!
				</p>
			</>,
			<>
			<span
				className="event-mac-body-head"
				style={{ padding: "1.25rem 0", color: "var(--bgcolor)" }}
			>
				Pre requisites
			</span>
			<ul style={{ listStyle: "none" }}>
				<li style={{ padding: "0.25rem 0" }}>
				Have a well-researched paper with clear objectives, methodology, results, and conclusions.
				Clear and concise slides that highlight the key points of your research.The presentation can be delivered by a team, with the stipulation that the maximum number of members in a team should not exceed four.
				</li>
			</ul>
		</>,
			
			<div style={{ display: "flex" }}>
				<Button
					size="small"
					text="Register Now"
					
					containsHref
					href="https://docs.google.com/forms/d/e/1FAIpQLSfKOo_Isym7ezI6HpGSy6SPoEFeobXVsbEYiqWs5z42WxvrYg/viewform?usp=sf_link"
				/>
				
			</div>,
			
		],
		backImg: _3back,
		aboutImgs: [_30, _31, _32],
		schedule: "24 April",
		
		others: (
			<>
				<div>MEC SYMCOSCI</div>
			</>
		),
	},
	{
		title: "Code Blitz",
		content: [
			<>
				Join us for an exhilarating Coding Challenge where participants showcase their problem-solving skills and expertise in debugging code. Dive into a series of challenging coding problems and demonstrate your ability to identify and fix bugs efficiently. Test your coding prowess and compete against fellow enthusiasts to emerge victorious in this thrilling event!
			</>,
			<>
				<span
					className="event-mac-body-head"
					style={{ padding: "1.25rem 0", color: "var(--bgcolor)" }}
				>
					Pre requisites
				</span>
				<ul style={{ listStyle: "none" }}>
					<li style={{ padding: "0.25rem 0" }}>
					Proficiency in at least one programming language is essential. The choice of language may depend on the competition rules.
					Familiarity with a code editor or Integrated Development Environment (IDE) that you’ll use during the competition.
					</li>
				</ul>
			</>,
			<div style={{ display: "flex" }}>
				<Button
					text="Register Now"
					containsHref
					href="https://forms.gle/b2kWHCiKGmmDTCbw5"
				/>
			</div>,
		],
		backImg: _6back,
		aboutImgs: [_60, _61, _62],
		schedule: "24 April",
		
	},
	{
		title: "Venture Fair",
		content: [
			<>
				Event where participants showcase their innovative projects in diverse fields. From cutting-edge technologies to creative solutions, witness a showcase of ingenuity and inspiration. Engage with passionate creators, explore groundbreaking ideas, and be inspired by the future of innovation. Don't miss this opportunity to witness the power of creativity and collaboration. Be part of an event that celebrates innovation, fosters learning, and ignites curiosity. Mark your calendars and join us for an unforgettable experience. Innovation knows no bounds—let your ideas take center stage and inspire the world.
			</>,
			<>
			<span
				className="event-mac-body-head"
				style={{ padding: "1.25rem 0", color: "var(--bgcolor)" }}
			>
				Pre requisites
			</span>
			<ul style={{ listStyle: "none" }}>
				<li style={{ padding: "0.25rem 0" }}>
				Have a completed or near-completed project that you can present.
				Be aware of your presentation time limit and structure your presentation accordingly.
				</li>
			</ul>
		</>,
			
			<div style={{ display: "flex" }}>
				<Button
					text="Register Now"
					containsHref
					href="https://forms.gle/ao92UCBybQ8xdxcz6"
				/>
			</div>,
		],
		backImg: _4back,
		aboutImgs: [_40, _41, _42],
		schedule: "24 April",
		
		others: (
			<>
				<div>Hello World</div>
			</>
		),
	},
	{
		title: "Cipher Code",
		content: [
			<>
				If you love messing around with riddles then this event will
				surely awaken the Sherlock in you. ‘Open Sesame’ is a classic
				fun event that will require the participating teams to decode
				the clue provided in PDF format. With each step, the team needs
				to decipher the riddles and crack the clue which will be the
				password for the next PDF. This could be the best possible way
				to integrate creative thinking with aptitude analysis.
			</>,
			<>
				<Button
					text="Register Now"
					containsHref
					href="https://docs.google.com/forms/d/e/1FAIpQLScceLXN9d9X_2PZAfrb67cqPzOSxMS9nkWm-E6-QMixw-iweg/viewform"
				/>
			</>,
		],
		backImg: _0back,
		aboutImgs: [_00, _01, _02],
		mode: "Discord",
		schedule: "25 Dec - 26 Dec",
		rules: [
			"Use of the internet is allowed",
			"Disclosing or discussing clues between teams is not allowed.",
			"Clues are divided into 17 levels.",
			"Each team has to clear the previous level to reach the next level within the given timeline.",
			"Teams will consist of not more than 3 members.",
		],
		prizes: [
			{
				title: "Winner",
				about: "INR 2000/-",
			},
			{
				title: "Runners up",
				about: "INR 1500/-",
			},
			{
				title: "2nd Runners up",
				about: "INR 1000/-",
			},
		],
		others: (
			<>
				<div>Hello World</div>
			</>
		),
	},
	{
		title: "Memory Maze",
		content: [
			<>
				<cite>
				Test your memory prowess! Navigate through a challenging maze of recollections. Sharpen your mind, beat the maze, and win the prize!
				</cite>
			</>,
			<>
				<div style={{ textAlign: "right" }}> -- Warren Buffett</div>
			</>,
			<>
				Ever thought of investing in the stock market but never tried
				because of no experience? If so, we have brought this event for
				you, where you can pick stocks and create your very own
				portfolio with the virtual money we provide you. Compete among
				other minds and create the best portfolio which provides the
				maximum return and wins the prize money
			</>,
			<>
				In our event, we will provide you a platform to invest in some
				NSE stocks and create your portfolio which will be analyzed by
				us
			</>,
			<>
				We will be searching for the best portfolio with the maximum
				return
			</>,
			<>
				<span
					className="event-mac-body-head"
					style={{ padding: "1.25rem 0", color: "var(--bgcolor)" }}
				>
					Pre requisites
				</span>
				<ul style={{ listStyle: "none" }}>
					<li style={{ padding: "0.25rem 0" }}>
						Basic knowledge of Investment and Stock Market.
					</li>
					<li style={{ padding: "0.25rem 0" }}>
						Knowledge on how to make portfolios.
					</li>
				</ul>
			</>,
			<div style={{ display: "flex" }}>
				{/* <Button
					text="Register Now"
					containsHref
					href="https://Symcoscistonks.herokuapp.com/signup"
				/> */}
			</div>,
		],
		backImg: _1back,
		aboutImgs: [_10, _11, _12],
		schedule: "25 Dec - 26 Dec",
		
		others: (
			<>
				<div>Hello World</div>
			</>
		),
	},
	{
		title: "Game Freak",
		content: [
			<>
				Gamers! Join "Game Freak" for adrenaline-pumping mobile gaming! Whether you're a seasoned player, showcase your skills and strategize with your squad. From intense firefights to strategic maneuvers, prove your prowess and emerge victorious! Gear up, form your teams, and let the games begin!
			</>,
			<div style={{ display: "flex" }}>
				<Button
					text="Register Now"
					containsHref
					href="https://forms.gle/Kq6zRNqvGJS5NQNU8"
				/>
			</div>,
		],
		backImg: _5back,
		aboutImgs: [_50, _51, _52],
		schedule: "25 Dec - 26 Dec",
	},
	
];
export default events;
